import { createSelector } from '@ngrx/store';
import { getAppStateSliceKey, getChartState, } from 'ChartApp/ts/features/fund-chart-page-shared/state/fund-chart-base.selectors';
import { CHART_INTERACTIVE_MODE, NAME_IN_LEGEND_OPTIONS } from 'ChartApp/ts/features/charts-shared/constants';
import { DATA_IN_FOOTER_OPTIONS, DATA_IN_LEGEND_OPTIONS, FUND_CHART_OPTIONS, } from 'ChartApp/ts/features/fundamental-chart/constants';
import { FundChartOptionValue, } from 'ChartApp/ts/interfaces/fund-chart.interface';
export const getChartOptions = (store) => {
    return {
        [FundChartOptionValue.SHOW_CUSTOM_COLORS]: store[FundChartOptionValue.SHOW_CUSTOM_COLORS],
        [FundChartOptionValue.DATA_IN_LEGEND]: store[FundChartOptionValue.DATA_IN_LEGEND],
        [FundChartOptionValue.SHOW_FORWARD_ESTIMATES]: store[FundChartOptionValue.SHOW_FORWARD_ESTIMATES],
        [FundChartOptionValue.NAME_IN_LEGEND]: store[FundChartOptionValue.NAME_IN_LEGEND],
        [FundChartOptionValue.SHOW_UNITS_IN_LEGEND]: store[FundChartOptionValue.SHOW_UNITS_IN_LEGEND],
        [FundChartOptionValue.SHOW_US_RECESSIONS]: store[FundChartOptionValue.SHOW_US_RECESSIONS],
        [FundChartOptionValue.USE_LOG_SCALE]: store[FundChartOptionValue.USE_LOG_SCALE],
        [FundChartOptionValue.HIDE_VALUE_FLAGS]: store[FundChartOptionValue.HIDE_VALUE_FLAGS],
    };
};
export const getFundChartDropdownConfig = createSelector(getAppStateSliceKey, getChartState, (appStateSliceKey, chartState) => {
    const dropdownConfig = {
        title: {
            label: 'Chart Options',
        },
    };
    // Depending on whether we are in the fundamental chart app
    // or creator, we start with different options.
    const baseOptions = FUND_CHART_OPTIONS;
    // Certain options have custom boolean values
    // when selected and we need to set them up.
    const options = baseOptions.map((option) => {
        const optionCopy = { ...option };
        // If options have a true / false value, set appropriately
        if (option.trueValue && option.falseValue) {
            optionCopy.selected = chartState[option.value] === option.trueValue;
        }
        else {
            optionCopy.selected = !!chartState[option.value];
        }
        return optionCopy;
    });
    // For the fundamental chart app we need to remove certain options if we are in presentation mode
    // versus interactive so only remove options when we are on that app.
    if (appStateSliceKey === 'fundChart' && chartState.chartType === CHART_INTERACTIVE_MODE) {
        dropdownConfig.list = options.filter((o) => !o.presentationOnly);
    }
    else {
        dropdownConfig.list = options;
    }
    return dropdownConfig;
});
export const getNameInLegendDropdownConfig = createSelector(getChartState, (chartState) => {
    const options = NAME_IN_LEGEND_OPTIONS.map((option) => {
        return {
            ...option,
            selected: chartState.nameInLegend === option.value,
        };
    });
    const dropdownConfig = {
        title: {
            label: 'Name in Legend',
        },
        list: options,
    };
    return dropdownConfig;
});
export const getDataInLegendDropdownConfig = createSelector(getChartState, (chartState) => {
    const options = DATA_IN_LEGEND_OPTIONS.map((option) => {
        return {
            ...option,
            selected: chartState[FundChartOptionValue.DATA_IN_LEGEND] === option.value,
        };
    });
    const dropdownConfig = {
        title: {
            label: 'Data in Legend',
        },
        list: options,
    };
    return dropdownConfig;
});
export const getDataInFooterDropdownConfig = createSelector(getAppStateSliceKey, getChartState, (appStateSliceKey, chartState) => {
    const dropdownConfig = {
        title: {
            label: 'Data in Footer',
        },
    };
    // Depending on whether we are in the fundamental chart app
    // or creator, we start with different options.
    const baseOptions = DATA_IN_FOOTER_OPTIONS;
    // Certain options have custom boolean values
    // when selected and we need to set them up.
    const options = baseOptions.map((option) => {
        const optionCopy = { ...option };
        // If options have a true / false value, set appropriately
        if (option.trueValue && option.falseValue) {
            optionCopy.selected = chartState[option.value] === option.trueValue;
        }
        else {
            optionCopy.selected = !!chartState[option.value];
        }
        return optionCopy;
    });
    // For the fundamental chart app we need to remove certain options if we are in presentation mode
    // versus interactive so only remove options when we are on that app.
    if (appStateSliceKey === 'fundChart' && chartState.chartType === CHART_INTERACTIVE_MODE) {
        dropdownConfig.list = options.filter((o) => !o.presentationOnly);
    }
    else {
        dropdownConfig.list = options;
    }
    return dropdownConfig;
});
